import { useEffect } from 'react';
import * as server from '../server';
import * as actions from '../store/actions';
import { useDispatch } from 'react-redux';

export const useClientIP = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            const { data: { clientIp } } = await server.getClientIP();

            dispatch(actions.setClientIP(clientIp));
        })();
    }, [dispatch]);
};
